import portretten from './portretten';
import kerken from './kerken';
import plattegronden from './plattegronden';
import skylines from './skylines';
import relief from './relief';
import diverse from './diverse';
// import kerken from './kerken';
// import plattegronden from './plattegronden';
// import skylines from './skylines';

const categories = [
  { id: 'portretten', name: 'Portretten', products: portretten },
  { id: 'kerken', name: 'Kerken', products: kerken },
  { id: 'plattegronden', name: 'Plattegronden', products: plattegronden },
  { id: 'skylines', name: 'Skylines', products: skylines },
  { id: 'relief', name: 'Relief', products: relief },
  { id: 'diverse', name: 'Diverse', products: diverse },
];

export default categories; 